/**
 * Rôle applicatif porté par `users/{uid}.userRight`.
 *
 * Le champ a deux formes en base : une chaîne sur les comptes anciens
 * (`"admin"`) et un objet `{ value, isBEA }` sur les comptes récents. Une
 * comparaison directe (`userRight === "admin"`, `[...].includes(userRight)`)
 * rate la forme objet et traite un admin de parc comme un soigneur.
 *
 * @param {string | { value?: string } | null | undefined} userRight
 * @returns {string | null} la valeur du rôle, ou `null` si elle est absente.
 */
export const readUserRole = (userRight) => {
  const value = typeof userRight === "string" ? userRight : userRight?.value;
  return typeof value === "string" && value.trim() ? value.trim() : null;
};

/**
 * @param {string | { value?: string } | null | undefined} userRight
 * @param {string[]} roles
 */
export const hasUserRole = (userRight, roles) => {
  const role = readUserRole(userRight);
  return role !== null && roles.includes(role);
};
